export function typesenseServerConfig({
  host = window.location.hostname,
  port = window.location.port || (window.location.protocol === "https:" ? "443" : "80"),
  protocol = window.location.protocol.replace(":", ""),
  path = null,
  additionalHeaders = {},
} = {}) {

  return {
    // The gateway replaces this required SDK placeholder with a server-side key.
    apiKey: "gateway-managed",
    nodes: [
      {
        host,
        port,
        protocol,
        ...(path && { path }),
      },
    ],
    connectionTimeoutSeconds: 10,
    numRetries: 4,
    additionalHeaders,
  };
}

export const searchConfig = typesenseServerConfig();

export const dictionaryConfig = typesenseServerConfig({
  host: import.meta.env.VITE_DICTIONARY_TYPESENSE_HOST || window.location.hostname,
  port:
    import.meta.env.VITE_DICTIONARY_TYPESENSE_PORT ||
    window.location.port ||
    (window.location.protocol === "https:" ? "443" : "80"),
  protocol:
    import.meta.env.VITE_DICTIONARY_TYPESENSE_PROTOCOL ||
    window.location.protocol.replace(":", ""),
  path: import.meta.env.VITE_DICTIONARY_TYPESENSE_PATH || "/search_dictionary",
});
